import {
    VISITSTORETOPURCHASE_GET_ERROR,
    VISITSTORETOPURCHASE_GET_REQUEST,
    VISITSTORETOPURCHASE_GET_SUCCESS,
    VISITSTORETOPURCHASE_ZIPCODE_CHANGE,
} from '../actionTypes/VisitStoreToPurchaseActionTypes';

function VisitStoretoPurchaseReducer(state = {}, action) {
    switch (action.type) {
        case VISITSTORETOPURCHASE_GET_ERROR:
            return { ...state, isLoading: false };
        case VISITSTORETOPURCHASE_GET_REQUEST:
            return action.visitStoreToPurchase;
        case VISITSTORETOPURCHASE_GET_SUCCESS:
            return { ...action.vStoreToPurchase, isLoading: false };
        case VISITSTORETOPURCHASE_ZIPCODE_CHANGE:
            return { ...state, showLoader: true, zipCode: action.payload };
        default:
            return state;
    }
}

export default VisitStoretoPurchaseReducer;
